module.exports = __webpack_public_path__ + "static/media/pic07.5d8e0d36.png";